import script from "./kechengjieshao.vue?vue&type=script&setup=true&lang=js"
export * from "./kechengjieshao.vue?vue&type=script&setup=true&lang=js"

import "./kechengjieshao.vue?vue&type=style&index=0&id=5efdea78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5efdea78"]])

export default __exports__